import { useMutation } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { AddBoxFirstManagerOrders } from 'services/addBox'
import { RootState } from 'store/redux'
import { resetImage } from 'store/redux/image'
import { reset } from 'store/redux/moneyPoolBox'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useAddBox() {
    // read at render: `reset()` below clears the store before the event fires
    const goal = useSelector((state: RootState) => state.MoneyPoolBoxAdd?.goal)
    const finishFlow = useFinishFlow(FLOWS.createFund)
    const dispatch = useDispatch()
    const { mutate } = useMutation({
        mutationFn: (payload: IAddBoxFirstManagerOrdersPayload) => {
            return AddBoxFirstManagerOrders(payload)
        },
        onSuccess: (_, variables) => {
            toast.success('سوابق مدیر با موفقیت به صندوق شما اضافه شد')
            dispatch(reset())
            dispatch(resetImage())
            posthog.capture('fund_created', {
                creation_path: 'with_manager_history',
                goal: goal || undefined,
            })
            finishFlow('/funds')
        },
        onError: () => {
            posthog.capture('fund_create_failed', {
                creation_path: 'with_manager_history',
                goal: goal || undefined,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return {
        mutate,
    }
}
